import {
  ANGULAR_SERVICE_WORKER_MESSAGE_TYPES as SERVICE_WORKER_ANGULAR_SERVICE_WORKER_MESSAGE_TYPES,
  ANGULAR_SERVICE_WORKER_MESSAGE_ACTIONS as SERVICE_WORKER_ANGULAR_SERVICE_WORKER_MESSAGE_ACTIONS
} from '../../../../ServiceWorker/src/constants/angular-messaging.constants';

export { SERVICE_WORKER_ANGULAR_SERVICE_WORKER_MESSAGE_TYPES as ANGULAR_SERVICE_WORKER_MESSAGE_TYPES };
export { SERVICE_WORKER_ANGULAR_SERVICE_WORKER_MESSAGE_ACTIONS as ANGULAR_SERVICE_WORKER_MESSAGE_ACTIONS };
